(function(){
  var header = document.getElementById('s2c-header');
  var chrome = header ? header.closest('.s2c-chrome') : null;
  var hamburger = document.getElementById('s2c-menu-toggle');
  var drawer = document.getElementById('s2c-menu-drawer');
  var searchToggle = document.getElementById('s2c-search-toggle');
  var searchClose = document.getElementById('s2c-search-close');
  var searchOverlay = document.getElementById('s2c-search-overlay');

  // Elevation shadow on scroll — chrome itself is always sticky via CSS.
  var stuckPoint = 40;
  window.addEventListener('scroll', function(){
    if (!chrome) return;
    if (window.scrollY > stuckPoint) chrome.classList.add('is-stuck');
    else chrome.classList.remove('is-stuck');
  }, { passive: true });

  // Mobile drawer
  function openDrawer(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); hamburger.classList.add('is-open'); hamburger.setAttribute('aria-expanded','true'); document.body.style.overflow = 'hidden'; }
  function closeDrawer(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); hamburger.classList.remove('is-open'); hamburger.setAttribute('aria-expanded','false'); document.body.style.overflow = ''; }
  if (hamburger) hamburger.addEventListener('click', function(){ drawer.classList.contains('is-open') ? closeDrawer() : openDrawer(); });
  if (drawer) drawer.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click', closeDrawer); });

  // Multi-level drawer panel navigation
  (function(){
    var mdrawer = drawer && drawer.querySelector('[data-mdrawer]');
    if (!mdrawer) return;
    var stack = ['root'];
    function showPanel(name){
      mdrawer.querySelectorAll('.s2c-mdrawer__panel').forEach(function(p){
        p.classList.toggle('is-active', p.dataset.panel === name);
      });
      mdrawer.scrollTop = 0;
    }
    mdrawer.addEventListener('click', function(e){
      var goBtn = e.target.closest('[data-go]');
      if (goBtn) { e.preventDefault(); stack.push(goBtn.dataset.go); showPanel(goBtn.dataset.go); return; }
      var backBtn = e.target.closest('[data-back]');
      if (backBtn) { e.preventDefault(); if (stack.length > 1) { stack.pop(); showPanel(stack[stack.length - 1]); } return; }
    });
    // Reset to root each time drawer opens — wrap original openDrawer.
    // The hamburger's addEventListener references this var by closure, so reassigning
    // is enough; do NOT also attach .onclick (would double-fire and toggle twice,
    // making the drawer flash open + close on a single tap = "nothing happens" on mobile).
    var origOpen = openDrawer;
    openDrawer = function(){ origOpen(); stack = ['root']; showPanel('root'); };
  })();

  // Search overlay
  function openSearch(){ searchOverlay.hidden = false; requestAnimationFrame(function(){ searchOverlay.classList.add('is-open'); var i = searchOverlay.querySelector('input'); if(i) i.focus(); }); document.body.style.overflow = 'hidden'; }
  function closeSearch(){ searchOverlay.classList.remove('is-open'); setTimeout(function(){ searchOverlay.hidden = true; }, 400); document.body.style.overflow = ''; }
  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', function(e){ if (e.target === searchOverlay) closeSearch(); });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') {
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      if (searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
    }
  });

  // Predictive search
  var searchInput = searchOverlay && searchOverlay.querySelector('[data-s2c-search-input]');
  var searchDefault = searchOverlay && searchOverlay.querySelector('[data-s2c-search-default]');
  var searchLive = searchOverlay && searchOverlay.querySelector('[data-s2c-search-live]');
  var searchEmpty = searchOverlay && searchOverlay.querySelector('[data-s2c-search-empty]');
  var searchEmptyQ = searchOverlay && searchOverlay.querySelector('[data-s2c-search-empty-q]');
  var searchSeeAll = searchOverlay && searchOverlay.querySelector('[data-s2c-search-see-all]');
  var searchAbort = null;
  var searchTimer = null;

  function renderLive(query, data) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
    var pages = (data.resources && data.resources.results && data.resources.results.pages) || [];

    var hasAny = products.length + collections.length + pages.length > 0;
    if (!hasAny) {
      searchLive.hidden = true;
      searchDefault.hidden = true;
      if (searchEmptyQ) searchEmptyQ.textContent = query;
      searchEmpty.hidden = false;
      return;
    }
    searchDefault.hidden = true;
    searchEmpty.hidden = true;

    var parts = [];
    if (products.length > 0) {
      parts.push('<div class="s2c-ps__grp"><div class="eyebrow eyebrow--em">Produkter</div><ul class="s2c-ps__prods">');
      products.slice(0, 6).forEach(function(p) {
        var img = p.image || (p.featured_image && p.featured_image.url) || '';
        var priceFmt = p.price != null ? (Math.round(parseFloat(p.price)).toLocaleString('da-DK') + ' kr.') : '';
        parts.push('<li><a href="' + p.url + '" class="s2c-ps__prod">' +
          (img ? '<span class="s2c-ps__prod-img"><img src="' + img + '" alt="' + escapeHtml(p.title || '') + '" loading="lazy"></span>' : '<span class="s2c-ps__prod-img"></span>') +
          '<span class="s2c-ps__prod-body"><span class="s2c-ps__prod-title">' + escapeHtml(p.title) + '</span>' +
          (priceFmt ? '<span class="s2c-ps__prod-price">' + priceFmt + '</span>' : '') +
          '</span></a></li>');
      });
      parts.push('</ul></div>');
    }
    if (collections.length > 0) {
      parts.push('<div class="s2c-ps__grp"><div class="eyebrow eyebrow--em">Kollektioner</div><ul class="s2c-ps__links">');
      collections.slice(0, 4).forEach(function(c) {
        parts.push('<li><a href="' + c.url + '">' + escapeHtml(c.title) + '</a></li>');
      });
      parts.push('</ul></div>');
    }
    if (pages.length > 0) {
      parts.push('<div class="s2c-ps__grp"><div class="eyebrow eyebrow--em">Sider</div><ul class="s2c-ps__links">');
      pages.slice(0, 4).forEach(function(p) {
        parts.push('<li><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></li>');
      });
      parts.push('</ul></div>');
    }
    parts.push('<a href="' + (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'search?q=' + encodeURIComponent(query) + '" class="s2c-ps__all">Se alle resultater for "' + escapeHtml(query) + '" →</a>');

    searchLive.innerHTML = parts.join('');
    searchLive.hidden = false;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  function doSearch(query) {
    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product,collection,page' +
              '&resources[limit]=8&resources[limit_scope]=each' +
              '&resources[options][unavailable_products]=last';
    fetch(url, { signal: searchAbort.signal, headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(data){ renderLive(query, data); })
      .catch(function(err){ if (err && err.name === 'AbortError') return; });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function(e){
      var q = (e.target.value || '').trim();
      if (searchSeeAll) searchSeeAll.href = '/search?q=' + encodeURIComponent(q);
      clearTimeout(searchTimer);
      if (q.length < 2) {
        searchLive.hidden = true;
        searchEmpty.hidden = true;
        searchDefault.hidden = false;
        return;
      }
      searchTimer = setTimeout(function(){ doSearch(q); }, 180);
    });
  }
})();

(function(){
  var groups = document.querySelectorAll('.s2c-chrome__navgroup.has-mega');
  var panels = document.querySelectorAll('[data-mega-panel]');
  if (!groups.length || !panels.length) return;
  var hideTimer;

  function closeAll() { panels.forEach(function(p){ p.classList.remove('is-open'); }); }
  function openPanel(idx) {
    clearTimeout(hideTimer);
    closeAll();
    var panel = document.querySelector('[data-mega-panel="' + idx + '"]');
    if (panel) panel.classList.add('is-open');
  }
  function scheduleClose() {
    hideTimer = setTimeout(closeAll, 160);
  }

  groups.forEach(function(g){
    var idx = g.dataset.megaTrigger;
    g.addEventListener('mouseenter', function(){ openPanel(idx); });
    g.addEventListener('mouseleave', scheduleClose);
  });
  panels.forEach(function(p){
    p.addEventListener('mouseenter', function(){ clearTimeout(hideTimer); });
    p.addEventListener('mouseleave', scheduleClose);
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });
})();
// rev2
